import React, { useEffect, useState } from "react";
import axios from 'axios';
import { useParams, Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './CourseItem.css';

const CourseItem = () => {
    const { cid } = useParams();
    const [course, setCourse] = useState({});

    const fetchCourse = () => {
        axios.get('https://lerntutors.com/react_2026_api/courses/courses.php?cid=' + cid, {timeout: 5000})
        .then(res => res.data)
        .then(data => data ? setCourse(data) : setCourse({}))
        .catch(err =>{
            console.error(err);
            window.location.reload();
        });
    }

    const cpreq = course.cprereq && course.cprereq !== 'None' ? course.cprereq.split(';') : [];
    const cable = course.cpoints ? course.cpoints.split(';') : [];

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            fetchCourse();
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
        return () => mounted = false;
    }, [])

    return (
        <div className="lern-courseitem">
            <div className="course-heading">
                <h2>{course.cname}</h2>
            </div>
            <div className="course-details">
                <figure className="course-img">
                    <img src={`https://lerntutors.com/storage/courses/${course.cimage}`} alt="Course Icon" />
                    <figcaption>
                        <p><strong>Level: </strong>{course.clevel}</p>
                        <p><strong>Duration: </strong>{course.cduration}</p>
                        <p><strong>Pre-requisites:</strong></p>
                        {
                            cpreq.length > 0 ? 
                            <ul>
                            {cpreq.map((cp, i) => (
                                <li key={i}>{cp}</li>
                            ))}
                            </ul>
                            :
                            (
                                <p>None</p>
                            )
                        }
                        <p><strong>Live Project: </strong>{course.cproject}</p>
                        <div className="course-enroll">
                            <Link to={`/enroll/${cid}`}>Enroll</Link>
                        </div>
                    </figcaption>
                </figure>
                <div className="course-info">
                    <p><strong>About this course:</strong><br />{course.cdesc}</p>
                    <p><strong>By the end of this course, you should be able to do the following:</strong></p>
                    {
                        cable.length > 0 ? 
                        <ul>
                        {cable.map((ca, i) => (
                            <li key={i}>{ca}</li>
                        ))}
                        </ul>
                        :
                        (
                            <p>None</p>
                        )
                    }
                    <p><strong>On-site Date: </strong>{course.consite_date}</p>
                    <p><strong>Online Date: </strong>{course.conline_date}</p>
                    <p><strong>On-site Cost: </strong>{course.consite_cost ? parseFloat(course.consite_cost).toLocaleString('en-US', {style: 'currency', currency: 'NGN'}) : 0}</p>
                    <p><strong>Online Cost: </strong>{course.conline_cost ? parseFloat(course.conline_cost).toLocaleString('en-US', {style: 'currency', currency: 'NGN'}) : 0}</p>
                </div>
            </div>
            <div className="back-btn">
                <Link to="/courses">Back to Courses</Link>
            </div>
        </div>
    )
}

export default CourseItem;